import React from 'react'
import '../../styles/mdx.scss'

export default function FlexColumn2({ children }) {
  return (
    <div className="mdx">
        <div className="mdx__flexcolumn2">
            { children }
        </div>
    </div>
  )
}
